import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {OrdersStatistic} from '../models/orders-statistic';


export const ordersStatisticListActionTypes = {
  LOAD: type('[Orders statistic list] Load'),
  LOAD_SUCCESS: type('[Orders statistic list] Load Success'),
  LOAD_FAIL: type('[Orders statistic list] Load Fail'),
  EXPORT: type('[Orders statistic list] Export data'),
  EXPORT_SUCCESS: type('[Orders statistic list] Export Success'),
};

export class LoadOrdersStatisticListAction implements Action {
  readonly type = ordersStatisticListActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class LoadOrdersStatisticListSuccessAction implements Action {
  readonly type = ordersStatisticListActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: ArrayResponse<OrdersStatistic>) {}
}

export class LoadOrdersStatisticListFailAction implements Action {
  readonly type = ordersStatisticListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

export class OrdersStatisticListExportAction implements Action {
  readonly type = ordersStatisticListActionTypes.EXPORT;
  constructor(public payload?: {
    startdate: string,
    enddate:  string
  }) {}
}
export class OrdersStatisticListExportSuccessAction implements Action {
  readonly type = ordersStatisticListActionTypes.EXPORT_SUCCESS;
  constructor() {}
}
